/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Envision - blog sidebar filter navigation scripts
  var blogContainer = document.querySelectorAll(".blog-section");
  if (blogContainer.length) {
    // Get all elements with class "fliter-tab"
    var filterTabs = document.querySelectorAll(".fliter-tab");
    
    // Add click event listeners to each "fliter-tab" element
    filterTabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        // Toggle the "show" class on the clicked element
        this.classList.toggle("show");
    
        // Get the "sidebar_content" element
        var sidebarContent = document.querySelector(".sidebar_content");
    
        // Toggle the slide effect of "sidebar_content"
        if (sidebarContent.style.display === "none" || sidebarContent.style.display === "") {
          sidebarContent.style.display = "block";
        } else {
          sidebarContent.style.display = "none";
        }
      });
    });
    
    // Get all elements with class "nav-title" inside ".blog-sidebar .nav-block"
    var navTitles = document.querySelectorAll(".blog-sidebar .nav-block .nav-title");
    
    // Add click event listeners to each "nav-title" element
    navTitles.forEach(function (title) {
      title.addEventListener("click", function () {
        // Toggle the "is-open" class on the clicked element
        this.classList.toggle("is-open");
    
        // Get the sibling "nav-list" element
        var navList = this.nextElementSibling;
    
        // Toggle the slide effect of "nav-list"
        if (navList.style.display === "none") {
          navList.style.display = "block";
        } else {
          navList.style.display = "none";
        }
      });
    });
    
    // Get all elements with class "has-child" inside ".blog-sidebar .nav-block ul.nav-list li"
    var hasChildItems = document.querySelectorAll(".blog-sidebar .nav-block ul.nav-list li.has-child");
    
    // Add click event listeners to each "has-child" element
    hasChildItems.forEach(function (item) {
      item.addEventListener("click", function () {
        // Toggle the "is-open" class on the clicked element
        this.classList.toggle("is-open");
      });
    });
  }

  // Envision - remove padding from Accordion Groups when their Collapsible Elements are empty
  document.querySelectorAll(".accordion-group").forEach(accordionGroup => {
    if (accordionGroup.querySelector("collapsible-elements").textContent.trim() === "") {
      accordionGroup.style.padding = 0;
    }
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
